__turbopack_context__.v({
  "markdownBody": "MDXContent-module__F1fy3q__markdownBody",
  "table": "MDXContent-module__F1fy3q__table",
  "tableBody": "MDXContent-module__F1fy3q__tableBody",
  "tableCell": "MDXContent-module__F1fy3q__tableCell",
  "tableHead": "MDXContent-module__F1fy3q__tableHead",
  "tableHeaderCell": "MDXContent-module__F1fy3q__tableHeaderCell",
  "tableRow": "MDXContent-module__F1fy3q__tableRow",
  "tableWrapper": "MDXContent-module__F1fy3q__tableWrapper",
});
